
























import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Vue } from 'vue-property-decorator';
import { EyeIcon, EyeOffIcon } from 'vue-feather-icons';

@Component({
  components: { EyeIcon, EyeOffIcon },
})
export default class BlurryLink extends Vue {
  get isBlurry(): boolean {
    return this.$store.getters['PreferencesModule/isBlurred'];
  }

  set isBlurry(val: boolean) {
    this.$store.dispatch('PreferencesModule/blur', val);
  }
}
